export const PAYMENT_SOURCE_OPTIONS: { value: string; label: string }[] = [
  { value: "CxC Avoi Brasil", label: "CxC Avoi Brasil" },
  { value: "Binance Cripto", label: "Binance Cripto" },
  { value: "Trust Cripto", label: "Trust Cripto" },
  { value: "Aliado Coloca", label: "Aliado Coloca" },
  { value: "Cobru", label: "Cobru" },
  { value: "Iris", label: "Iris" },
  { value: "Kamin", label: "Kamin" },
  { value: "Kamin 2", label: "Kamin 2" },
  { value: "BBVA", label: "BBVA" },
  { value: "Davivienda", label: "Davivienda" },
  { value: "Droplatam Colombia", label: "Droplatam Colombia" },
  { value: "Droplatam Ecuador", label: "Droplatam Ecuador" },
  { value: "Droplatam México", label: "Droplatam México" },
  { value: "Droplatam Perú", label: "Droplatam Perú" },
  { value: "Droplatam Panamá", label: "Droplatam Panamá" },
  { value: "Droplatam Paraguay", label: "Droplatam Paraguay" },
  { value: "Droplatam Chile", label: "Droplatam Chile" },
  { value: "Dropi Colombia", label: "Dropi Colombia" },
  { value: "Dropi México", label: "Dropi México" },
  { value: "Dropi Chile", label: "Dropi Chile" },
  { value: "Dropi Ecuador", label: "Dropi Ecuador" },
  { value: "Dropi Panamá", label: "Dropi Panamá" },
  { value: "Dropi España", label: "Dropi España" },
  { value: "Dropi Paraguay", label: "Dropi Paraguay" },
  { value: "Dropi Guatemala", label: "Dropi Guatemala" },
  { value: "Bitso México", label: "Bitso México" },
  { value: "Bitso USD", label: "Bitso USD" },
  { value: "OKX", label: "OKX" },
  { value: "Wiilog Colombia", label: "Wiilog Colombia" },
  { value: "Wiilog Ecuador", label: "Wiilog Ecuador" },
];
